



































































































































































































import { UserStore } from '@/store/modules/user';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSBreadcrumb from '../../components/AMSBreadcrumb.vue';
import AMSTable from '../../components/AMSTable.vue';
import AMSTooltip from '@/components/AMSTooltip.vue';
import utils from '@/utils/utils';
import AMSDialog from '@/components/AMSDialog.vue';
import { emptyRule } from '@/utils/rules';
import request from '@/utils/request';
import moment from 'moment';
import Charge from './charge.vue';
import Ship from './ship.vue';
import { stock, shippedList, accountHistory } from '@/api/order';
import AMSProductImg from '@/components/AMSProductImg.vue';
import { logistics, cancelShip, getShipStatusName, shipBySf, shipCompany, cancel, ship, getShipCompanyName } from '@/api/shipment';
@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-table': AMSTable,
    'ams-tooltip': AMSTooltip,
    'ams-dialog': AMSDialog,
    'ams-charge-record': Charge,
    'ams-ship-record': Ship
  }
})
export default class pendingDetails extends Vue {
  valid: boolean = true;
  confirmDialog: boolean = false;
  confirmLoading: boolean = false; //按钮弹窗（确认取消）
  confirmMemo: string = ''; //弹框备注 必填
  modalType: string = '';
  nameRules: Array<any> = [emptyRule('备注')];
  tabValue: any = null;
  activeTab: any = null;
  BreadItem = [
    {
      text: '订单管理',
      disabled: false,
      href: '/orderList'
    },
    {
      text: '订单列表',
      disabled: false,
      href: '/orderList'
    },
    {
      text: '订单详情',
      disabled: true
    }
  ];
  pendingDetails: any = null;
  // 操作信息header
  operateHeaders = [
    {
      text: '操作者',
      align: 'left',
      render: (h: any, param: any) => {
        return h('div', `${param.row.operator.name}  `);
      },
      width: 150
    },
    { text: '操作时间', align: 'left', value: 'creationTime', width: 200, isFormatDateTime: true },
    {
      text: '操作类型',
      align: 'left',
      width: 150,
      render: (h: any, param: any) => {
        return h('span', this.switchOrderOperateType(param.row.operateType)!.text);
      }
    },
    {
      text: '订单状态',
      align: 'left',
      width: 180,
      render: (h: any, param: any) => {
        return h(
          'span',
          {
            style: {
              color: this.switchStatus(param.row.newState)!.color
            }
          },
          `${param.row.oldState ? this.switchStatus(param.row.oldState)!.text : ''} ${param.row.oldState ? '->' : ''}${this.switchStatus(param.row.newState)!.text}`
        );
      }
    },
    {
      text: '备注',
      value: 'Remark',
      maxWidth: 80,
      Width: 80,
      type: 'html',
      render: (h: any, param: any) => {
        var text = `${param.row.remark ? param.row.remark : ''} <br/>${param.row.itemChanges}`;
        return h('div', {
          props: {},
          domProps: {
            innerHTML: text
          }
        });
      }
    }
  ];
  // 商品信息(待确认状态的)header
  productHeaders = [
    {
      text: '序号',
      align: 'center',
      render: (h: any, param: any) => {
        return h('div', `${param.index + 1}  `);
      },
      width: '50px'
    },
    {
      text: '商品',
      render: (h: any, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row.product,
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true
          }
        });
      },
      align: 'left',
      width: 300
    },
    {
      text: '容量',
      align: 'right',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product.capacity || ''}`);
      },
      width: 120
    },
    {
      text: '数量',
      align: 'right',
      width: 120,
      sortable: false,
      value: 'quantity',
      isInputNumber: { type: 'orderQuantity' }
    },
    {
      text: '单价',
      value: 'price',
      align: 'right',
      sortable: false,
      width: 120,
      isInputNumber: {
        type: 'disCount'
      }
    },
    {
      text: '小计',
      align: 'right',
      width: 120,
      value: 'totalPrice',
      render: (h: any, param: any) => {
        return h('div', `￥${this.formatPrice(param.row.totalPrice)}  `);
      }
    }
  ];
  // 不是待确认状态的header
  noPendingConfirmproductHeaders = [
    {
      text: '序号',
      align: 'center',
      render: (h: any, param: any) => {
        return h('div', `${param.index + 1}  `);
      },
      width: '50px'
    },
    {
      text: '商品',
      value: 'product',
      render: (h: any, param: any) => {
        return h(AMSProductImg, {
          props: {
            // product: param.row.product,
            product: param.row[param.keyName],
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true
          }
        });
      },
      align: 'left',
      width: 300
    },
    {
      text: '容量',
      align: 'right',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product.capacity || ''}`);
      },
      width: 120
    },
    {
      text: '数量',
      align: 'right',
      width: 120,
      render: (h: any, param: any) => {
        return h('div', `${param.row.quantity} `);
      }
    },
    {
      text: '单价',
      align: 'right',
      render: (h: any, param: any) => {
        return h('div', `￥${this.formatPrice(param.row.price)} `);
      },
      width: 120
    },
    {
      text: '小计',
      align: 'right',
      width: 120,
      value: 'totalPrice',
      render: (h: any, param: any) => {
        return h('div', `￥${this.formatPrice(param.row.totalPrice)}  `);
      }
    }
  ];
  // 已完成状态（关闭header）
  cancelproductHeaders = [
    {
      text: '序号',
      align: 'center',
      render: (h: any, param: any) => {
        return h('div', `${param.index + 1}  `);
      },
      width: '50px'
    },
    {
      text: '商品',
      value: 'product',
      render: (h: any, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row[param.keyName],
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true
          }
        });
      },
      align: 'left',
      width: 300
    },
    {
      text: '容量',
      align: 'right',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product.capacity || ''}`);
      },
      width: 120
    },
    {
      text: '数量',
      align: 'right',
      width: 120,
      render: (h: any, param: any) => {
        return h('div', `${param.row.quantity} `);
      }
    },
    {
      text: '单价',
      align: 'right',
      render: (h: any, param: any) => {
        return h('div', `￥${this.formatPrice(param.row.price)} `);
      },
      width: 120
    },
    {
      text: '小计',
      align: 'right',
      width: 120,
      value: 'price',
      render: (h: any, param: any) => {
        return h('div', `￥${this.formatPrice(param.row.price * param.row.quantity)}  `);
      }
    }
  ];
  stockData: any = {}; //已出库清单
  shippedData: any = {}; //发货清单
  chargeData: any = {}; //扣款记录清单
  allocation = []; // 配货
  showTab: Boolean = true;
  orderId: string | (string | null)[] = '';
  isExternalShipper :Boolean = false;//账户角色是否为外部仓库发货员
  
  created() {
    this.isExternalShipper = UserStore.isExternalShipper
    if( this.isExternalShipper){
      this.productHeaders.splice(4,2)
      this.noPendingConfirmproductHeaders.splice(4,2)
      this.cancelproductHeaders.splice(4,2)
    }
    this.orderId = this.$route.query.id;
    this.getOrderDetails();
    if (this.$route.query.tabActive == 'Ship') {
      window.scrollTo(0, 0);
      this.activeTab = 'Ship';
    }
    this.getPendingAllocation();
    this.getStockList();
    this.getShippedList();
    this.getChargeData();
  }
  refreshShipRecord() {
    this.getPendingAllocation();
    this.getStockList();
    this.getShippedList();
  }
  refreshchargeRecord() {
    this.getChargeData();
  }
  //扣款记录
  getChargeData() {
    if (!this.$route.query || !this.$route.query.id) return;
    accountHistory(this.$route.query.id as string)
      .then(response => {
        this.chargeData = response;
        this.chargeData.deductAmount = utils.formatCurrencyPrice(this.chargeData.deductAmount);
        this.chargeData.freezeAmount = utils.formatCurrencyPrice(this.chargeData.freezeAmount);
        this.chargeData.orderAmount = utils.formatCurrencyPrice(this.chargeData.orderAmount);
        this.chargeData.items.map((v: any) => {
          v.operateTime = v.operateTime ? utils.formatDateByFormat(v.operateTime, 'yyyy-MM-dd hh:mm:ss') : '';
          v.amount = utils.formatCurrencyPrice(v.amount);
          v.products.map((p: any) => {
            p.amount = utils.formatCurrencyPrice(p.amount);
            p.price = utils.formatCurrencyPrice(p.price);
          });
        });
      })
      .catch(error => {});
  }
  //tab显示
  showTabActive() {
    if (this.pendingDetails.state) {
      if (this.pendingDetails.state === 'PendingConfirm' || this.pendingDetails.state === 'Pending') {
        return false;
      } else if (this.pendingDetails.state === 'Order' || this.pendingDetails.state === 'Finished' || this.pendingDetails.state === 'PartialDelivery') {
        return true;
      } else if (this.pendingDetails.state === 'Canceled') {
        if ((this.stockData && this.stockData.length > 0) || (this.shippedData.items && this.shippedData.items.length > 0)) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  formatDateTime(date: string) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  getOrderDetails() {
    request.get(`/api/Order/${this.orderId}`).then((data: any) => {
      this.pendingDetails = data;
    });
  }
  //modal确认提示文言
  getModalConfirm() {
    if (this.pendingDetails.state === 'PendingConfirm' && this.modalType === 'PendingConfirm') {
      return '确定将订单价格提交审核吗？';
    } else if (this.modalType == 'cancel') {
      if (this.pendingDetails.state === 'PartialDelivery') {
        return '商品已部分发货，确定取消未发货的商品，取消后，已出库的商品将取消出库并释放库存';
      } else {
        return '确定取消订单吗？';
      }
    } else if (this.modalType == 'backConfirm') {
      return '确定将该订单返回确认吗？';
    } else if (this.modalType == 'Pending') {
      return '确定将该订单通过审核吗？';
    }
  }
  // 按钮确认弹窗关闭
  confirmClose() {
    this.confirmDialog = false;
    this.confirmLoading = false;
  }
  //modal确认
  confirmSure(stop: Function) {
    if ((this.$refs.form as any).validate()) {
      this.confirmLoading = true;
      if (this.modalType === 'cancel') {
        //取消订单
        this.cancelOrder(stop);
      } else if (this.modalType === 'Pending' || this.modalType === 'backConfirm') {
        //通过审核 ||返回确认
        this.reviewOrder(stop, this.modalType === 'Pending' ? true : false);
      } else if (this.modalType === 'PendingConfirm') {
        //确认订单
        this.confirmOrder(stop);
      }
    } else {
      stop();
    }
  }

  // 确认订单
  confirmOrder(stop: Function) {
    let orderList: any = [];
    this.pendingDetails.items.map((item: any) => {
      let temp: any = {};
      temp['id'] = item.id;
      temp['quantity'] = item.quantity !== '' ? item.quantity : 1;
      temp['price'] = item.price !== '' ? Number(item.price) : 0;
      temp['totalPrice'] = item.totalPrice !== '' ? item.totalPrice : 0;
      orderList.push(temp);
    });
    request
      .post(`/api/Order/${this.orderId}/Confirm`, {
        orderId: this.orderId,
        remark: this.confirmMemo,
        items: orderList
      })
      .then(data => {
        this.confirmDialog = false;
        this.getOrderDetails();
      })
      .finally(() => {
        this.confirmLoading = false;
        stop();
      })
      .catch(err => {
        stop();
        this.confirmLoading = false;
      });
  }
  // 通过审核 ||返回确认
  reviewOrder(stop: Function, isPendingPass: boolean) {
    request
      .post(`/api/Order/${this.orderId}/Review`, {
        orderId: this.orderId,
        remark: this.confirmMemo,
        isPendingPass
      })
      .then(data => {
        this.confirmDialog = false;
        this.getOrderDetails();
      })
      .finally(() => {
        stop();
        this.confirmLoading = false;
      });
  }
  // 确认取消订单
  pendingConfirm(modalType: string) {
    (this.$refs.form as any).resetValidation();
    this.modalType = modalType;
    this.confirmDialog = true;
    this.confirmMemo = '';
    this.confirmLoading = false;
  }
  /********* 配送出库*/
  getPendingAllocation() {
    request.get(`/api/Order/${this.$route.query.id}/pendingAllocation`).then((data: any) => {
      this.allocation = data.items;
      this.allocation = data.items.map((item: any) => {
        if (item.product) {
          item.id = item.product.id;
        }
        item.quantity = 0;
        return item;
      });
    });
  }
  /**获取订单已出库清单 */
  getStockList() {
    if (!this.$route.query || !this.$route.query.id) return;
    stock(this.$route.query.id as string)
      .then((response: any) => {
        this.stockData = response.items;
        this.stockData.map((v: any) => {
          v.statusName = getShipStatusName(v.status);
          v.stockTime = v.stockTime ? utils.formatDateByFormat(v.stockTime, 'yyyy-MM-dd hh:mm:ss') : '';
          v.cancelStockTime = v.cancelStockTime ? utils.formatDateByFormat(v.cancelStockTime, 'yyyy-MM-dd hh:mm:ss') : '';
        });
      })
      .catch(error => {});
  }
  /**获取订单已发货清单 */
  getShippedList() {
    if (!this.$route.query || !this.$route.query.id) return;
    shippedList(this.$route.query.id as string)
      .then((response: any) => {
        this.shippedData = response.items;
        this.shippedData.map((v: any) => {
          v.statusName = getShipStatusName(v.status);
          v.stockTime = v.stockTime ? utils.formatDateByFormat(v.stockTime, 'yyyy-MM-dd hh:mm:ss') : '';
          v.cancelStockTime = v.cancelStockTime ? utils.formatDateByFormat(v.cancelStockTime, 'yyyy-MM-dd hh:mm:ss') : '';
          v.logisticsCompanyName = getShipCompanyName(v.logisticsCompany);
          v.shippedTime = v.shippedTime ? utils.formatDateByFormat(v.shippedTime, 'yyyy-MM-dd') : '';
        });
      })
      .catch((error: any) => {});
  }
  //取消订单
  cancelOrder(stop: Function) {
    request
      .post(`/api/Order/${this.orderId}/Cancel`, { orderId: this.orderId, remark: this.confirmMemo })
      .then(data => {
        this.confirmDialog = false;
        this.getOrderDetails();
        this.refreshShipRecord();
      })
      .finally(() => {
        stop();
        this.confirmLoading = false;
      });
  }
  formatPrice(num: number) {
    return utils.formatCurrencyPrice(num);
  }
  sumArr(arr: any, itemName: string, itemName2: string) {
    if (arr) {
      var sum = 0;
      let Arr: any = [];
      arr.map((item: any) => {
        if (itemName2) {
          Arr.push(item[itemName] * item[itemName2]);
        } else {
          Arr.push(item[itemName]);
        }
      });
      var sum = 0;
      Arr.forEach(function(val: any) {
        sum += Number(val);
      });
      return sum;
    }
  }
  getModalTitle(status: string) {
    switch (status) {
      case 'cancel':
        return '取消订单';
      case 'Pending':
        return '通过审核';
      case 'backConfirm':
        return '审核不通过，返回确认';
      case 'PendingConfirm':
        return '确定订单';
      case 'PartialDelivery':
        return '部分发货';
      case 'Order':
        return '待发货';
      case 'Finished':
        return '已完成';
      case 'Canceled':
        return '已关闭';
    }
  }
  // 订单详情的状态
  switchStatus(status: string) {
    switch (status) {
      case 'Pending':
        return { color: '#FE5500 ', text: '待审核' };
      case 'PendingConfirm':
        return { color: '#FF0000', text: '待确认' };
      case 'PartialDelivery':
        return { color: '#FF0000', text: '部分发货' };
      case 'Order':
        return { color: '#FF0000', text: '待发货' };
      case 'Finished':
        return { color: '#00A854', text: '已完成' };
      case 'Canceled':
        return { color: '', text: '已关闭' };
    }
  }
  // 操作详情的操作type OrderOperateType
  switchOrderOperateType(status: string) {
    switch (status) {
      case 'Submit':
        return { color: '#FE5500', text: '提交订单' };
      case 'ConfirmPrice':
        return { color: '#00A854', text: '确认订单价格' };
      case 'Approve':
        return { color: 'lightpink', text: '审核通过' };
      case 'BackToConfirm':
        return { color: 'lightpink', text: '返回确认' };
      case 'AllocationAndOutStock':
        return { color: '#00a679', text: ' 配货并出库' };
      case 'CancelOutStock':
        return { color: '#00a679', text: '取消出库' };
      case 'Ship':
        return { color: '#00a679', text: ' 确认发货' };
      case 'CancelShip':
        return { color: '#00a679', text: ' 取消发货' };
      case 'CancelOrder':
        return { color: '#00a679', text: '  取消订单' };
    }
  }
  // tabChange
  tabActived(value: string) {
    if (this.activeTab === 'Ship') {
      this.refreshShipRecord();
    } else if (this.activeTab === 'Charge') {
      this.getChargeData();
    }
  }
  getPermission(name: string) {
    return utils.isPermission(name);
  }
}
